import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';
import facebookLogo from '../assets/icons/facebook.png';
import twitterLogo  from '../assets/icons/twitter.png';
import youtubeLogo  from '../assets/icons/youtube.png';
import phoneIcon from '../assets/icons/phone-white.png'
import { ReactComponent as ChevronRight } from '../assets/icons/chevron-right.svg';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        {/* Top Links */}
        <div className="footer-top">
          <div className="footer-col">
            <h4>Products</h4>
            <ul>
              <li><Link to="/sell-transformers">Transformers</Link></li>
              <li><Link to="/sell-pvf">Pipes, Valves, Fittings</Link></li>
              <li><Link to="/sell-electrical">Electrical Equipment</Link></li>
              <li><Link to="/sell-surplus">Related Equipment</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Resources</h4>
            <ul>
              <li><Link to="/transformer-guides">Transformer Guides</Link></li>
              <li><Link to="/pvf-guides">PVF Guides</Link></li>
              <li><Link to="/electrical-guides">Electrical Guide</Link></li>
              {/*<li><Link to="/roi-calculator">ROI Calculator</Link></li>*/}
              <li><Link to="/kva-calculator">kVA Calculator</Link></li>
              <li><Link to="/fault-current-calculator">Fault Current Calculator</Link></li>
              <li><Link to="/pvf-sizing">PVF Sizing Calculator</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Who We Are</h4>
            <ul>
              <li><Link to="/about-us">About S&D</Link></li>
              <li><Link to="/company-history">History</Link></li>
              <li><Link to="/contact-us">Contact</Link></li>
              <li><Link to="/safety-and-compliance">Safety and Compliance</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/under-construction">Careers</Link></li>
            </ul>
          </div>
          {/* add more columns as needed */}
        </div>

        {/* Divider */}
        <hr className="footer-divider" />

        {/* Social + Language */}
        <div className="footer-social-row">
          <a href="https://twitter.com" className="social-link">
            <img src={twitterLogo} className="social-icon" alt="Twitter" />
          </a>
          <a href="https://facebook.com" className="social-link">
            <img src={facebookLogo} className="social-icon" alt="Facebook" />
          </a>
          <a href="https://youtube.com" className="social-link">
            <img src={youtubeLogo} className="social-icon" alt="YouTube" />
          </a>

          <div className="language-selector">
            English (United States)
            <ChevronRight />
          </div>
        </div>
        <div className="address">
            <span className="address-company">S&D Industrial Surplus</span><br/>
            Texas Office: 11665 Fuqua, Suite E507
            Houston, Texas 77034
            <br/>
            <br/>
            Alabama Office:1501 Jordan lane,
            Huntsville, Alabama 35816
            <a href="tel:8328852369" className="phone-link-footer">
                <div className="phone-wrapper-footer">
                    <img src={phoneIcon} alt="" className="phone-icon" />
                    <p>(832) 885-2369</p>
                </div>
                </a>

        </div>
      </div>
    </footer>
  );
}
